module.exports = __webpack_public_path__ + "img/img(5).dd02a2ae.png";